var $c25de0af306f5a70$exports = {};
$c25de0af306f5a70$exports = {
    "loading": `Laden...`,
    "loadingMore": `Mehr laden ...`
};


export {$c25de0af306f5a70$exports as default};
//# sourceMappingURL=de-DE.module.js.map
